import { BackendData } from "./backendDataParser";

export function SelectClient(currentValue: any, key: any) {
    const localStorageValue = window.localStorage.getItem(key);
    if ((localStorageValue && localStorageValue !== currentValue) || localStorageValue === null || localStorageValue === undefined) {
        window.localStorage.setItem(key, JSON.stringify(currentValue));
    }
    window.location.reload();
}

export function ClientOptions(currentValue: any, key: any) {
    const localStorageValue = window.localStorage.getItem(key);
    if ((localStorageValue && localStorageValue !== currentValue) || localStorageValue === null || localStorageValue === undefined) {
        window.localStorage.setItem(key, JSON.stringify(currentValue));
    }
}

export function getSelectedClient() {
    try {
        const selectedClientJson = localStorage.getItem('selectedClient');

        if (selectedClientJson === null) {
            throw new Error('Selected backend cannot be null');
        }

        const selectedClient: BackendData = JSON.parse(selectedClientJson);

        return selectedClient;
    } catch (error) {
        console.log(error);

        throw error;
    }
}

export function ClearLocalStorageItem(itemName: string) {
    window.localStorage.removeItem(itemName);
}